export interface LottieAsset {
  light: string;
  dark: string;
}

export const CHECK_LOTTIE: LottieAsset = {
  light:
    "https://lottie.host/1b238c65-7fae-4ada-9c14-03dafb8b6ceb/aydslhs1Rc.json",
  dark: "https://lottie.host/c17bf6ff-679c-4a33-9ab1-777ab6730030/U3Sk4VWATX.json",
};
